import BigNumber from "bignumber.js";

const bigNumberCache = new Map();

export function getBigNumber(value) {
  if (isNaN(value)) return new BigNumber(0); // NaN 방지
  const key = value.toString();
  if (!bigNumberCache.has(key)) {
    bigNumberCache.set(key, new BigNumber(value));
  }
  return bigNumberCache.get(key);
}